import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentText12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconDocumentText12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.5 1h3.417v4.083H10V10.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5m7.178 2.833a1 1 0 0 1 .197.25H6.917v-2.8zM9.5 12h-7A1.5 1.5 0 0 1 1 10.5v-9A1.5 1.5 0 0 1 2.5 0h3.718a2 2 0 0 1 1.357.53l2.782 2.568A2 2 0 0 1 11 4.568V10.5A1.5 1.5 0 0 1 9.5 12M4 5a.5.5 0 0 0 0 1h.5a.5.5 0 0 0 0-1zm-.5 2.5A.5.5 0 0 1 4 7h4a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5M4 9a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentText12);
